import { settings } from '../resources'
import getText from './strings'

const regex = (value, rule, customErrorMessage) => {
  const message = customErrorMessage || getText('validate', 'regexFailed')
  return rule.test(value) === false ? message : undefined
}

export const email = value => {
  return regex(value, /^[A-Z0-9ÆØÅÄÖæøåäö._%+-]+@[A-Z0-9ÆØÅÄÖæøåäö.-]+\.[A-ZÆØÅÄÖæøåäö]{2,20}$/i, getText('validate', 'emailRegexFailed'))
}

export const bookingNumber = value => {
  if (!value)
    return undefined
  return regex(value, /^(1|3|6|a|b)[(\w|\d)]{6}$/i, getText('validate', 'bookingNumberRegexFailed'))
}


export const atcomOrCrsBookingNumber = value => {
  if (!value)
    return undefined
  return value.length < 6 || value.length > 23 ? getText('validate', 'bookingNumberFailed') : undefined
}

export const passwordMinLength = value => {
  if (!value)
    return undefined
  return value.length < 6 ? getText('validate', 'minLengthPassword') : undefined
}

export const gigyaPassword = value => {
  if (!value)
    return getText('validate', 'validationRequired')

  let groups = 0

  if (/[A-Z,Å,Ä,Ö]/.test(value))
    groups++

  if (/[a-z,å,ä,ö]/.test(value))
    groups++

  if (/[0-9]/.test(value))
    groups++

  if (/([^A-Z,a-z,ÅÄÖåäö,0-9\s])/.test(value))
    groups++

  return value.length < 8 || groups < 2 ? getText('validate', 'gigyaPassword') : undefined

}

export const noWhiteSpace = value => {
  return regex(value, /^\S*$/i)
}

export const emailOrPhoneNumber = value => {
  return regex(value, /^(.+@.+)|((\+?)[0-9]{2,5}[/|\-|]?[0-9]{4,})?$/, getText('validate', 'emailOrPhoneRequiredFailed'))
}

export const phoneNumber = value => {
  return regex(value, /^\d+$/, getText('validate', 'notPhoneNumber'))
}

export const date = value => {
  return regex(value, settings.dateRegex, getText('validate', 'regexFailed'))
}

export const required = value => {
  return value ? undefined : getText('validate', 'validationRequired')
}

export const fileSize = (maxSizeMB, customErrorMessage) => {
  return value => {
    const message = customErrorMessage || `Filesize of ${maxSizeMB}Mb exceeded`
    return (value && value.size > maxSizeMB * 1024 * 1024)
      ? message
      : undefined
  }
}

export const compare = field => {
  return (value, allValues) => {
    return value === allValues[field]
      ? undefined
      : getText('validate', 'validationCompareFailed')
  }
}